import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { APPROVED_SALES_LISTING,LEDGER_LISTING,GET_SITE_CHALLAN } from "./type";

export const getApprovedSaleListing = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    console.log(queryObj)
    filterQuery = `&lead_id=${queryObj.leadID}&site_no=${queryObj.siteID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}
    &created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}
    &city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate
    }&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&commercial_type_id=${queryObj.commercial_type_id}&page=${page}`;
  }

  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;


    var teams = await JSON.parse(localStorage.getItem("profileDetails"));
    var teamId = [];
    teams.forEach((team, index) => {
      teamId.push(team.team_id);
    });
    if (queryObj !== null) {
      filterQuery += `&teamId=${teamId}`;
    }

  console.log(teamName)
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && departmentName === 2) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.approvalList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.approvalList}?lead_type=1`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.approvalList}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.approvalList}?lead_type=4`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.approvalList}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.approvalList}?lead_type=2`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.approvalList}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.approvalList}?lead_type=3`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.approvalList}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.approvalList}?lead_type=4`;
    } else if (teamId && teamId.includes(21)) {
      apiUrl = queryObj
          ? `${Config.preSalesList.approvalList}?lead_type=1${filterQuery}`
          : `${Config.preSalesList.approvalList}?lead_type=1`;
    }

    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });


    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}${queryObj === null && `&page=${page}&teamId=${teamId}`}`
    );

    if (res) {
      const { data } = res;
      const outer = data;
      const payload = outer?.response ?? outer;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: payload?.data ?? outer?.data,
      });
      return true;
    }
  }
  catch(err) {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};

//Ledger API
export const getLedgerListing = (businessId = null, queryObj = null, page = 1) => async (dispatch) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&from_date=${queryObj.from_date}&to_date=${queryObj.to_date}&entity_id=${queryObj.entity_id}&recon_business_id=${businessId}&page=${page}`;
  }
  try {
    let apiUrl;
    apiUrl = queryObj
      ? `${Config.ledgerBusiness.ledgerList}?${filterQuery}`
      : `${Config.ledgerBusiness.ledgerList}?page=${page}&recon_business_id=${businessId}`;

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: LEDGER_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: LEDGER_LISTING,
      payload: {},
    });
  }
};

export const downloadLedger = (businessId = null, queryObj = null, is_pdf=null) => async (dispatch) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&from_date=${queryObj.from_date}&to_date=${queryObj.to_date}&entity_id=${queryObj.entity_id}&recon_business_id=${businessId}`;
  }
  try {
    let apiUrl;
    apiUrl = queryObj
      ? `${Config.ledgerBusiness.ledgerDownload}?${filterQuery}`
      : `${Config.ledgerBusiness.ledgerDownload}?recon_business_id=${businessId}&is_pdf=${is_pdf}`;

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      return data;
    }
  }
  catch {
    return false;
  }
}

export const getChallansForSite = (site_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.getSiteChallan}?site_id=${site_id}`
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    dispatch({ type: GET_SITE_CHALLAN, payload });
    return payload;
  }
}
